/* BAKAMI · controllo lato browser dello stato vendite (chiuso / preordine / aperto).
   Le pagine possono essere servite dalla cache: se lo stato calcolato qui (ora di Roma) è diverso
   da quello con cui la pagina è stata generata, ricarichiamo una sola volta.
   Finché gli ordini sono chiusi blocchiamo comunque aggiunta al carrello e checkout. */
(function () {
  var b = document.body;
  if (!b || !b.dataset.bkState) return;
  var toNum = function (s) { return parseInt(String(s || '').replace(/-/g, ''), 10) || 0; };
  var today;
  try {
    today = toNum(new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Rome', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()));
  } catch (e) { return; }
  var open = toNum(b.dataset.bkOpen), ship = toNum(b.dataset.bkShip);
  var state = open && today < open ? 'closed' : ship && today < ship ? 'preorder' : 'open';

  var pf = toNum(b.dataset.bkPromoFrom), pt = toNum(b.dataset.bkPromoTo), pp = parseInt(b.dataset.bkPromoPct, 10) || 0;
  var promo = pp > 0 && pf && pt && today >= pf && today <= pt ? 'active' : 'inactive';
  if (b.dataset.bkPromo && promo !== b.dataset.bkPromo) {
    var pkey = 'bk-promo-reload-' + promo;
    try {
      if (!sessionStorage.getItem(pkey)) { sessionStorage.setItem(pkey, '1'); location.reload(); return; }
    } catch (e) {}
  }

  if (state !== b.dataset.bkState) {
    var key = 'bk-state-reload-' + state;
    try {
      if (!sessionStorage.getItem(key)) { sessionStorage.setItem(key, '1'); location.reload(); return; }
    } catch (e) {}
  }

  if (state === 'closed') {
    var block = function (e) {
      var t = e.target;
      var isAdd = t.closest && t.closest('form[action*="/cart/add"]');
      var isCheckout = t.closest && (t.closest('[name="checkout"]') || t.closest('form[action*="/checkout"]') || t.closest('a[href*="/checkout"]'));
      if (isAdd || isCheckout) { e.preventDefault(); e.stopImmediatePropagation(); }
    };
    document.addEventListener('submit', block, true);
    document.addEventListener('click', function (e) {
      if (e.target.closest && (e.target.closest('[name="checkout"]') || e.target.closest('a[href*="/checkout"]') || e.target.closest('.shopify-payment-button'))) {
        e.preventDefault(); e.stopImmediatePropagation();
      }
    }, true);
  }
})();
